/* nailspiracy-nav.js */
(() => {
  'use strict';
  if (window.__niNavInit) return;
  window.__niNavInit = true;

  const MQ = matchMedia('(min-width: 990px)');
  const DELAY = 150;
  const BODY = document.body;
  const DRAWER = document.getElementById('menu-drawer');
  const DRAWER_WRAP = document.getElementById('Details-menu-drawer-container');
  const qsa = (s, c = document) => c.querySelectorAll(s);

  function syncDrawerState() {
    if (DRAWER_WRAP) BODY.classList.toggle('ni-drawer-open', DRAWER_WRAP.open);
  }

  function getScrollParent(el) {
    for (let p = el && el.parentElement; p; p = p.parentElement) {
      const oy = getComputedStyle(p).overflowY;
      if ((oy === 'auto' || oy === 'scroll' || oy === 'overlay') && p.scrollHeight > p.clientHeight) {
        return p;
      }
    }
    return null;
  }

  function scrollIntoViewTop(el, gap = 10) {
    const scroller = getScrollParent(el);
    if (!scroller) return;
    const a = el.getBoundingClientRect();
    const b = scroller.getBoundingClientRect();
    scroller.scrollTop += a.top - b.top - gap;
  }

  function bindDesktop() {
    qsa('.header__inline-menu header-menu details').forEach((d) => {
      if (d.dataset.niBound) return;
      d.dataset.niBound = '1';

      let t;
      d.addEventListener('mouseenter', () => {
        clearTimeout(t);
        d.open = true;
      });

      d.addEventListener('mouseleave', () => {
        t = setTimeout(() => {
          d.open = false;
        }, DELAY);
      });
    });
  }

  function unbindDesktop() {
    qsa('.header__inline-menu header-menu details[open]').forEach((d) => {
      d.open = false;
    });
  }

  function initDrawer() {
    if (!DRAWER || !DRAWER_WRAP || DRAWER.dataset.niBound) return;
    DRAWER.dataset.niBound = '1';

    syncDrawerState();
    DRAWER_WRAP.addEventListener('toggle', syncDrawerState);

    DRAWER.addEventListener(
      'click',
      (e) => {
        const topSum = e.target.closest('.nd-item > .nd-summary');
        if (topSum) {
          const item = topSum.parentElement;

          requestAnimationFrame(() => {
            if (!item.open) return;
            qsa('.nd-item[open]', DRAWER).forEach((d) => {
              if (d !== item) d.open = false;
            });
            scrollIntoViewTop(topSum);
          });
          return;
        }

        const catSum = e.target.closest('.nd-cat > .nd-cat-summary');
        if (catSum) {
          const cat = catSum.parentElement;

          requestAnimationFrame(() => {
            if (!cat.open) return;

            const panel = cat.closest('.nd-panel');
            if (panel) {
              qsa('.nd-cat[open]', panel).forEach((d) => {
                if (d !== cat) d.open = false;
              });
            }

            requestAnimationFrame(() => scrollIntoViewTop(catSum));
          });
        }
      },
      true
    );
  }

  function boot() {
    if (MQ.matches) bindDesktop();
    initDrawer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  const onChange = (e) => (e.matches ? bindDesktop() : unbindDesktop());
  MQ.addEventListener ? MQ.addEventListener('change', onChange) : MQ.addListener(onChange);
})();